import { ADMIN_RESOURCE_REGISTRY as EFFECTIVE_ADMIN_RESOURCE_REGISTRY, } from './effective-admin-resource.registry.js';
import { ORGANIZATION_REGULATORY_PROFILE_FORM } from '../descriptors/organization-regulatory-profile-form.js';
import { OPERATION_IDS, ROUTE_IDS } from '../routes/ids.js';
const organizationRegulatoryProfile = Object.freeze({
    id: 'organization-regulatory-profile',
    authority: 'ORGANIZATION',
    scopeKind: 'ORGANIZATION',
    listRouteId: ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE,
    editRouteId: ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE,
    listOperationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_READ,
    readOperationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_READ,
    updateOperationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_UPDATE,
    tableDescriptorId: 'table.admin.organizationRegulatoryProfile',
    listQueryId: 'query.admin.organization-regulatory-profile.get',
    readQueryId: 'query.admin.organization-regulatory-profile.get',
    updateCommandId: 'cmd.admin.organization-regulatory-profile.update',
    formDescriptorId: ORGANIZATION_REGULATORY_PROFILE_FORM.id,
    ownershipPolicy: 'ACTIVE_ORGANIZATION',
    rowActivation: 'NONE',
    kind: 'bespoke',
});
export const ADMIN_RESOURCE_REGISTRY = Object.freeze({
    ...EFFECTIVE_ADMIN_RESOURCE_REGISTRY,
    'organization-regulatory-profile': organizationRegulatoryProfile,
});
export const RELEASED_ADMIN_RESOURCE_REGISTRY = ADMIN_RESOURCE_REGISTRY;
export function getAdminResourceDescriptor(id) {
    return ADMIN_RESOURCE_REGISTRY[id];
}
